import StatisticsScreen from './StatisticsScreen';

export default StatisticsScreen;
